import { useState, useCallback } from 'react';

export const useAlert = () => {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
  });

  const showAlert = useCallback((message, title = 'Alert', type = 'info') => {
    setAlertState({
      isOpen: true,
      title,
      message,
      type,
    });
  }, []);

  const showSuccess = useCallback((message, title = 'Success') => {
    showAlert(message, title, 'success');
  }, [showAlert]);

  const showError = useCallback((message, title = 'Error') => {
    showAlert(message, title, 'error');
  }, [showAlert]);

  const showWarning = useCallback((message, title = 'Warning') => {
    showAlert(message, title, 'warning');
  }, [showAlert]);

  const showInfo = useCallback((message, title = 'Information') => {
    showAlert(message, title, 'info');
  }, [showAlert]);

  const closeAlert = useCallback(() => {
    setAlertState(prev => ({ ...prev, isOpen: false }));
  }, []);

  return {
    alertState,
    showAlert,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    closeAlert,
  };
};

